<template>
  <div class="m-t-3 m-x-2">
    <div class="m-b-1" v-if="isReviews">
      <h4 class="h4 m-t-0 m-b-0" selenium="reviews-label">Reviews</h4>
      <span class="text-sm c-gray60" >Reviews across all Areas of Expertise</span>
    </div>
    <h4 v-else class="h4 m-t-0 m-b-2" selenium="reviews-label">Reviews</h4>
    <div>
      <div>
        <div class="layout">
          <div class="layout-item is-6:t m-r-6:t">
            <span class="text-bold">{{ overallTitle }}</span>
            <reviews-header
                v-if="combineMeta.aggregation"
                v-bind="combineMeta"
                @percentage-bar="filterHeaderRating" />
          </div>
          <div v-if="reviews.length" class="layout-item is-4:t m-r-6:t m-r-6:mo">
            <span
                v-if="combineMeta.aggregation.category_rating
                  && combineMeta.aggregation.category_rating.knowledge_average_rating !== 'NaN'
                && combineMeta.aggregation.category_rating.responsiveness_average_rating !== 'NaN'"
                class="text-bold">{{ attributeTitle }}</span>
            <review-categories
                v-if="combineMeta.aggregation.category_rating"
                :categories="combineMeta.aggregation.category_rating"
                :isMainHeader="isMainHeader"
            />
          </div>
        </div>
        <div class="bd-t-gray40 p-t-2 p-b-1" v-if="reviews.length">
          <span class="text-bold">{{ reviewCountText }}</span>
        </div>
      </div>

      <div class="SORTANDFILTER p-b-2" :class="{ 'bd-b-gray40 m-b-2': !reviews.length }">
        <div class="SORT flex-1-1 p-r-4:d">
          <div class="text-md c-gray70 p-b-1">Sort By</div>
          <select-box
              v-model="sortFilter.sorting"
              :options="$options.SORTKEYS"
              option-label="label"
              option-value="key"/>
        </div>
        <div v-if="!occupation_id">
          <div class="p-l-4:d FILTERBAR">
            <div class="c-gray70 p-b-1 d-none:mo">&nbsp;</div>
            <div class="m-t-2:mo">
              <filter-button class="BUTTON-GROUP" @click="showFilter = true"/>
              <filter-pill
                  class="BUTTON-GROUP m-l-1 m-y-1"
                  v-if="sortFilter.rating"
                  :label="` ${sortFilter.rating} ${sortFilter.rating > 1 ? 'stars' : 'star'}`"
                  @click="removeFilter('rating')"/>
              <filter-pill
                  class="BUTTON-GROUP m-l-1 m-y-1"
                  v-if="sortFilter.occupation_id"
                  :label="occupationName"
                  @click="removeFilter('occupation_id')"/>
            </div>
          </div>
        </div>
        <div v-else>
          <div v-if="sortFilter.rating" class="FILTER p-l-4:d FILTERBAR">
            <div class="c-gray70 p-b-1 d-none:mo">&nbsp;</div>
            <div class="m-t-2:mo">
              <filter-pill
                  class="BUTTON-GROUP m-l-1 m-y-1"
                  :label="` ${sortFilter.rating} ${sortFilter.rating > 1 ? 'stars' : 'star'}`"
                  @click="removeFilter('rating')"/>
            </div>
          </div>
        </div>
      </div>
      <div v-if="reviews.length">
        <div v-for="(review, index) in reviews" :key="index" class="text-md">
          <review-item :review="review" class="bd-t-gray40" />
        </div>
        <div class="text-center m-t-3 m-t-6:t">
          <page-pagination
              v-if="reviewTotal"
              :totalItemCount="reviewTotal"
              :pageSize="10" />
        </div>
      </div>
      <div v-else>No Reviews</div>
    </div>
    <review-filter-modal
        v-if="showFilter && combineMeta.aggregation"
        :initFilter="sortFilter"
        :occupationsName="combineMeta"
        @close="showFilter = false"
        @filter="onFilter"
    />
  </div>
</template>

<script>
import { getReviews } from '@homeservices/api-kit/search/reviews/v1';
import ReviewItem from '@/components/Reviews/ReviewWithPics';
import ReviewsHeader from '@/components/Reviews/ReviewsHeader';
import PagePagination from '@/components/Reviews/PagePagination';
import ReviewCategories from '@/components/ReviewCategories';
import ReviewFilterModal from '@/components/reviewFilterModal/';
import FilterButton from '@/components/FilterButton';
import FilterPill from '@/components/FilterPill';
import { keys } from '@/constants/reviewSortKeys';
import SelectBox from '@/components/SelectBox';
import capitalizeAll from '@/filters/capitalizeAll';

export default {
  SORTKEYS: keys,
  name: 'review-list',
  components: {
    ReviewsHeader,
    ReviewCategories,
    ReviewItem,
    PagePagination,
    ReviewFilterModal,
    FilterButton,
    FilterPill,
    SelectBox,
  },
  props: {
    service_providers_id: {
      required: true,
    },
    occupation_id: {
      default: null,
    },
    isMainHeader: {
      type: Boolean,
      required: false,
    },
    occupation_name: {
      type: String,
      required: false,
    },
  },
  data () {
    return {
      responseObj: {},
      reviews: [],
      reviewCount: 0,
      reviewTotal: 0,
      loadingReview: false,
      showFilter: false,
      sortFilter: {
        sorting: 'created_dtm desc',
        occupation_id: this.occupation_id,
      },
      occupationName: null,
      combineMeta: {},
    };
  },
  computed: {
    reviewCountText () {
      return `${Number(this.$route.query.from || 0) + 1}-
          ${Number(this.$route.query.from || 0) + this.reviewCount} of ${
  this.reviewTotal
}
          verified reviews`;
    },
    isReviews () {
      return this.$route.meta.reviews;
    },
    overallTitle () {
      return this.isReviews || !this.occupation_name
        ? 'Overall Ratings'
        : `Overall Ratings of ${capitalizeAll(this.occupation_name)}`;
    },
    attributeTitle () {
      return this.isReviews || !this.occupation_name
        ? 'Attribute Ratings'
        : `Attribute Ratings of ${capitalizeAll(this.occupation_name)}`;
    },

  },
  watch: {
    $route: {
      handler (newval) {
        this.fetchReviews(newval.query.from);
      },
    },
    service_providers_id: {
      immediate: true,
      handler (newval) {
        if (newval) {
          this.fetchReviews(0);
        }
      },
    },
    'sortFilter.sorting': {
      handler () {
        this.fetchReviews(0);
      },
    },
  },

  methods: {
    fetchReviews (fromval) {
      this.loadingReview = true;
      getReviews({
        ...this.sortFilter,
        from: fromval,
        size: 10,
        service_provider_id: this.service_providers_id,
      })
        .then(({ data }) => {
          this.setCombineMeta(data);
          this.responseObj = data;
          this.reviewTotal = data.total;
          this.reviews = data.results;
          this.reviewCount = this.responseObj.count;
        })
        .catch(() => {
          this.loadingReview = false;
        });
    },
    onFilter (evt) {
      this.showFilter = false;
      this.sortFilter = evt.data;
      this.occupationName = evt.occupation_name;
      this.fetchReviews(0);
    },
    removeFilter (type) {
      this.sortFilter[type] = null;
      this.fetchReviews(0);
    },
    setCombineMeta (data) {
      if (!Object.keys(this.combineMeta).length) {
        this.combineMeta = {
          aggregation: data.aggregation,
          total: data.total,
          from: 0,
          length: data.count,
        };
      }
    },
    filterHeaderRating (evt) {
      this.sortFilter.rating = evt;
      this.fetchReviews(0);
    },
  },
};
</script>
<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";


  .SORTANDFILTER {
    @include desktop {
      display: flex;
    }
    .SORT{
      @include tablet {
        max-width: 400px;
      }
    }
    .FILTERBAR{
      @include desktop {
        border-left: 1px solid $color-gray40;
      }
    }
    .BUTTON-GROUP {
      display: inline-block;
    }
  }
</style>
